import { render, staticRenderFns } from "./Studiengang.vue?vue&type=template&id=5f569431&scoped=true"
import script from "./Studiengang.vue?vue&type=script&lang=js"
export * from "./Studiengang.vue?vue&type=script&lang=js"
import style0 from "./Studiengang.vue?vue&type=style&index=0&id=5f569431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f569431",
  null
  
)

export default component.exports